export const getUrlSearchNumberParam = (name: string, default_: number) => {
  const query = new URLSearchParams(window.location.search);
  const value = query.get(name);
  if (value) return Number(value);
  return default_;
};
